/* iGreens - comanda minima 60 RON: afiseaza mesajul + dezactiveaza finalizarea sub prag.
   Functioneaza pe pagina /cart si in cart drawer (re-randat prin AJAX). */
(function () {
  var MIN = 6000;
  var css = '.min-order-notice{display:flex;align-items:flex-start;gap:10px;margin:14px 0;padding:12px 14px;border:1px solid #e3b341;border-left:4px solid #e3b341;background:#fff8e6;color:#5c4400;border-radius:4px;font-size:14px;line-height:1.45;text-align:left}' +
    '.min-order-notice[hidden]{display:none!important}' +
    '.min-order-notice__icon{flex:0 0 20px;width:20px!important;height:20px!important;margin-top:2px;color:rgb(176,125,0)}.min-order-notice__icon *{fill:none!important;stroke:currentColor!important;stroke-width:2!important}' +
    '.min-order-notice__text{margin:0}' +
    'body.is-below-min-order #dynamic-checkout-cart,body.is-below-min-order .previewCartGroup shopify-accelerated-checkout-cart,body.is-below-min-order .previewCartGroup .dynamic-checkout__content{display:none!important}' +
    '.button-checkout.is-min-disabled{opacity:.45;cursor:not-allowed;pointer-events:none}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' RON'; }
  function readTotal() {
    var els = document.querySelectorAll('[data-cart-total-value]');
    for (var i = 0; i < els.length; i++) {
      var v = parseInt(els[i].getAttribute('data-cart-total-value'), 10);
      if (!isNaN(v)) return v;
    }
    return null;
  }
  function apply() {
    var notices = document.querySelectorAll('[data-min-order-notice]');
    var total = readTotal();
    if (total === null) return;
    var below = total > 0 && total < MIN;
    document.body.classList.toggle('is-below-min-order', below);
    notices.forEach(function (n) {
      n.hidden = !below;
      var r = n.querySelector('[data-min-order-remaining]');
      if (r && below) r.textContent = fmt(MIN - total);
    });
    document.querySelectorAll('#cart-checkout, #cart-sidebar-checkout').forEach(function (b) {
      if (below) {
        if (!b.hasAttribute('data-min-disabled')) { b.setAttribute('data-min-disabled', b.disabled ? 'prev' : 'yes'); }
        b.disabled = true; b.classList.add('is-min-disabled'); b.setAttribute('aria-disabled', 'true');
      } else if (b.getAttribute('data-min-disabled') === 'yes') {
        b.disabled = false; b.classList.remove('is-min-disabled'); b.removeAttribute('aria-disabled'); b.removeAttribute('data-min-disabled');
      } else if (b.getAttribute('data-min-disabled') === 'prev') {
        b.classList.remove('is-min-disabled'); b.removeAttribute('data-min-disabled');
      }
    });
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 150); }
  document.addEventListener('DOMContentLoaded', function () {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-total-value'] });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#cart-checkout, #cart-sidebar-checkout');
    if (b && b.classList.contains('is-min-disabled')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();
